const featureFlags = {
  // ==========================================
  // Application Core & Infrastructure
  // ==========================================
  // Version management and update control
  herbieDashboardVersion: '0.0.1',
  forceUpdateVersionDashboard: false,

  // Early Access
  userEarlyAccess: false,

  // UI components and navigation
  sidebar: false,
  toggleFeatureFlag: false,
  sidebarIncidents: false,

  // PostHog kill switch: flip to false in LaunchDarkly to stop loading the
  // posthog-js SDK on new sessions (no identify, no survey fetch, no captures).
  posthogEnabled: true,

  // Developer and debugging tools
  developerTools: false,
  cobler: false,
  impersonate: false,

  // ==========================================
  // Monitoring & Device Tracking
  // ==========================================
  // Device monitoring and status
  activityCompletionStatus: false,
  devicesSlideSseTimeInMs: 10100,
  idleTime: true,
  removedDevice: false,
  showDeviceObservation: false,
  trackingForceVisibilityGeofence: false,
  /** LaunchDarkly key: `tracking-v2` — nova experiência de replay dedicado e histórico V2 */
  trackingV2: false,

  // ==========================================
  // Fleet Management
  // ==========================================

  sheetImportWithAi: false,

  /** LaunchDarkly key: `operational-health-card` — card "Saúde da operação" na home ongoing */
  operationalHealthCard: false,

  // Fleet events and tracking
  enableFleetEvents: false,
  enableV2FleetEvents: false,
  libraryExtensionEventSource: false,

  // Driver management and identification
  driverIdentification: false,
  driverSuggestion: false,
  enableDriverAssociationPast: false,
  identifierAssociations: false,
  clusterPhotoSuggestions: false,
  /** LaunchDarkly key: `face-id-v-1` — gates the Face ID V1 experience (overview/running-without-driver
   * tabs). When off, the vehicles and drivers pages show only their plain lists, with no tab bar. */
  faceIdV1: false,
  /** LaunchDarkly key: `driver-identification-method-qrcode` — gates the "QR Code" option in the
   * association source filter (path-association and camera events pages) to pilot fleets only. */
  driverIdentificationMethodQrcode: false,

  // Vehicle and driver allow lists
  allowList: false,
  enableVehicleDriverAllowList: false,

  // ==========================================
  // Media & Video Features
  // ==========================================
  // Livestream functionality
  livestream: false,
  livestreamPage: false,
  livestreamMulti: false,
  disableLivestreamTimeRestriction: false,
  livestreamConfig: {
    liveTimeout: 60,
    bannerTimeout: 30,
    bannerThreshold: 5,
  },

  /** LaunchDarkly key: `voice-chat` — gates the "Conversar" (voice chat) button in the vehicle
   * popup, next to the livestream button. V1: connection flow only, no audio (pooler phase 4). */
  voiceChat: false,

  // Video playback and events
  videoImpactEvent: false,
  /** LaunchDarkly key: `camera-streamax-new-events` — per-fleet gate for the Streamax (Gen4) event
   * types (pedestrian warning, no seat belt, moving with ignition off, low voltage, device
   * disconnection, abnormal temperature, low device battery, camera blocked). Default OFF: the new
   * types stay out of every event list and filter. */
  cameraStreamaxNewEvents: false,
  mediaEventLiveUpdate: false,
  videoEnhancedFeatures: false,
  cobliCamAiOverlay: false,
  videoEventSeverity: false,
  showObstructionDashboard: false,
  showMatchReview: false,
  multiCamVideoRequests: false,
  multiCamTimelapseRequests: false,
  cobliCamProRecordOff: true,

  // Video configuration
  disableWifiConfiguration: false,
  enforceCameraFeatures: false,

  // AI-powered
  aiChat: false,
  aiChecklist: false,
  /** LaunchDarkly key: `ai-config` — libera a página de configurações da Cobli IA (`/ai/config`) */
  aiConfig: false,
  /** LaunchDarkly key: `ai-automations` — libera as rotinas da Cobli IA: a página (`/ai/automations`),
   * a tela de execuções (`/ai/automations/:automationId`) e o item "Rotinas" na barra lateral do chat */
  aiAutomations: false,
  aiAnalyzeTrackingButton: false,
  aiVideosRecommendations: false,
  aiFilterAnnouncement: false,
  importIdentifierAi: false,
  /** LaunchDarkly key: `identification-token-inverted-byte-format` — controls byte-order display for fleets using Orbital readers */
  identificationTokenInvertedByteFormat: false,
  aiUserModalUpdate: false,

  // ==========================================
  // AI Recommendations
  // ==========================================
  aiRecommendations: false,
  aiRecommendations2: false,
  poisRecommendations: false,
  aiGroupRecommendations: false,

  // Audio features
  vehiclePopupAudioButton: false,

  // ==========================================
  // Analytics & Reporting
  // ==========================================
  // Fuel card integrations
  fuelCardAlelo: false,
  fuelCardManual: false,
  fuelCardMaxifrota: false,
  fuelCardPrime: false,
  fuelCardSodexo: false,
  fuelCardTicketlog: false,
  fuelCardCtasmart: false,
  fuelCardVolus: false,
  enableBrokenFuelCardIntegrationBanner: false,

  // Fuel AI research
  researchFuelAI: false,
  aiFuelOcr: false,

  // Reports and analytics
  showIncidentsReport: false,
  coblinator: false,
  safetyRankingDash: false,

  // ==========================================
  // Pages & Features
  // ==========================================
  // Navigation pages
  heavyUserMap: false,
  roadSpeedPage: true,
  expensesImportButton: true,
  finesPage: false,
  integrationsPage: false,
  deviceConfigWebhook: false,
  businessManager: true,
  assetTagFleets: false,

  // Feature-specific pages
  maintenance: false,
  canUseNonAssociatedVehiclesToRegisterMaintenanceAndTransaction: false,
  prismicAlertsNotAdoptedCohort: false,

  // ==========================================
  // Account & User Experience
  // ==========================================
  // Account configuration
  ongoingActivationTasks: false,
  announcementCard: false,
  usersNovosAi: false,

  // Contract renewal popup
  contractRenewalConfig: false,

  // Basic Value guided onboarding modal (LaunchDarkly key: basic-value-onboarding)
  basicValueOnboarding: false,

  // ==========================================
  // IoT & Device Control
  // ==========================================
  // Vehicle immobilizer
  enableImmobilizer: false,
  vehicleImmobilizer: false,

  // Remote connection
  useRemoteConnection: false,

  // ==========================================
  // Integrations & External Services
  // ==========================================
  // Address and location services
  internationalAddressAutocomplete: false,

  // Autocomplete de endereço self-hosted (OSM). LaunchDarkly key:
  // `osm-autocomplete-enabled`. Por fleet — fora da flag, Google Places.
  osmAutocompleteEnabled: false,

  // Communication services
  // NOTE: keep the catalog key as `blipChat` because that's the LaunchDarkly
  // flag name that gates Intercom. The implementation is Intercom; only the
  // flag key is legacy.
  blipChat: false,

  // ==========================================
  // Development & Monitoring Tools
  // ==========================================
  // Datadog RUM (Real User Monitoring)
  ddRumSampleRate: 100,
  ddRumReplaySampleRate: 0,
  useDdRum: false,

  // Push notifications
  oneSignal: false,

  // Temporary flags
  showWarningBanner: false,

  // Resumo de Alertas (Bulletin) — LaunchDarkly key: `blueprint-bulletin-enabled`.
  // Shared gate with the Blueprint SDUI stack so a single flag toggles the feature on
  // both the legacy and Blueprint alert forms. See `TriggerBulletinConfig` in modules/triggers.
  blueprintBulletinEnabled: false,
};

type FeatureFlags = typeof featureFlags;

export { featureFlags };
export default FeatureFlags;
